import React from "react";

const menuSections = [
  {
    title: "BREKKY",
    subtitle: "TIL 11AM",
    items: [
      {
        name: "Avo Toast",
        price: 13,
        description: "Add Chilli Oil",
        addPrice: 2
      },
      {
        name: "Bacon, Egg + Cheese",
        price: 17,
        description: "Chilli Mayo"
      }
    ]
  },
  {
    title: "TOASTIES",
    subtitle: "ALL DAY",
    items: [
      {
        name: "Misomite",
        price: 14,
        description: "Miso, Vegemite + Cheddar"
      },
      {
        name: "Ham + Pickles",
        price: 17,
        description: "Smoked Ham, Ched, Mozz, Zucchini Pickles + Mustard Mayo"
      },
      {
        name: "Tuna Melt",
        price: 18,
        description: "Provolone, Capers, Dill + Onion"
      }
    ]
  },
  // {
  //   title: "ADD ONS",
  //   subtitle: "",
  //   items: [
  //     {
  //       name: "Hell's Horses Hot Sauce",
  //       price: 1,
  //       description: ""
  //     },
  //     {
  //       name: "Ham",
  //       price: 5,
  //       description: ""
  //     },
  //     {
  //       name: "Cheese",
  //       price: 2,
  //       description: ""
  //     },
  //     {
  //       name: "Avo",
  //       price: 3,
  //       description: ""
  //     },
  //     {
  //       name: "GF Bread",
  //       price: 0.5,
  //       description: ""
  //     },
  //     {
  //       name: "Public Holiday Surcharge",
  //       description: "10%"
  //     }
  //   ]
  // },
  {
    title: "SANDWICHES",
    subtitle: "FROM 10:30AM",
    items: [
      {
        name: "Schnitz",
        price: 21,
        description: "Sweet zucchini pickle mayo, sesame panko crumb, pickled red onion + shredduce"
      },
      {
        name: "Morty D",
        price: 21,
        description: "Mortadella, pistachio pesto, stracciatella, basil + guindilla"
      },
      {
        name: "Korean Fried Mushroom",
        price: 21,
        description: "Sticky sauce, kimchi slaw + pickled radish"
      },
      {
        name: "Sun Kissed (v)",
        price: 20,
        description: "Nashi pear, halloumi, olive, almond, cucumber, pickled onion, mint yoghurt dressing"
      },
      {
        name: "The Deli One",
        price: 21,
        description: "Sopressa, prosciutto, fior di latte, balsamic, rocket, capsicum + olive, chilli + mayo"
      },
      {
        name: "*Special*",
        price: 21,
        description: "Sando Special"
      }
    ]
  },
  // {
  //   title: "DRINK SPECIALS",
  //   subtitle: "",
  //   items: [
  //     {
  //       name: "London Fog Hot/Iced",
  //       description: "$6/$8"
  //     },
  //     {
  //       name: "Parisian Hot Choc",
  //       price: 7,
  //       description: ""
  //     }
  //   ]
  // },
  // {
  //   title: "COFFEE + TEA",
  //   subtitle: "",
  //   items: [
  //     {
  //       name: "Regular",
  //       price: 5.5,
  //       description: ""
  //     },
  //     {
  //       name: "Large",
  //       price: 6,
  //       description: ""
  //     },
  //     {
  //       name: "Add Almond, Soy or Oat Milk",
  //       price: 0.7,
  //       description: ""
  //     },
  //     {
  //       name: "Batch",
  //       price: 5.5,
  //       description: ""
  //     },
  //     {
  //       name: "Green",
  //       price: 4,
  //       description: ""
  //     },
  //     {
  //       name: "English Breakfast",
  //       price: 4,
  //       description: ""
  //     },
  //     {
  //       name: "Sticky Chai",
  //       price: 5.5,
  //       description: ""
  //     },
  //     {
  //       name: "Turmeric",
  //       price: 5.5,
  //       description: ""
  //     }
  //   ]
  // },
  // {
  //   title: "ICED",
  //   subtitle: "",
  //   items: [
  //     {
  //       name: "Latte",
  //       price: 6,
  //       description: ""
  //     },
  //     {
  //       name: "Batch",
  //       price: 6,
  //       description: ""
  //     },
  //     {
  //       name: "Oat Chai",
  //       price: 6,
  //       description: ""
  //     },
  //     {
  //       name: "Milo Milkshake",
  //       price: 9,
  //       description: ""
  //     },
  //     {
  //       name: "Matcha",
  //       price: 8,
  //       description: ""
  //     },
  //     {
  //       name: "Add Maple Cold Foam",
  //       price: 2,
  //       description: ""
  //     }
  //   ]
  // }
];

export default function Menu() {
  return (
    <section className="site-menu" id="menu">
      <div className="site-menu-inner">
        {menuSections.map((section) => (
          <div className="site-menu-section" key={section.title}>
            <h2>{section.title}</h2>
            <p className="site-menu-subtitle">{section.subtitle}</p>

            {section.items.map((item) => (
              <article className="site-menu-item" key={item.name}>
                <h3>
                  {item.name}
                  {typeof item.price === "number" ? ` $${item.price}` : ""}
                </h3>
                {item.addPrice ? (
                  <p>
                    {item.description} ${item.addPrice}
                  </p>
                ) : item.description ? (
                  <p>{item.description}</p>
                ) : null}
              </article>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}

